import axios from 'axios'

const recruiterService = {
  uploadProfilePicture(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/update/profilepic',
        data: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteProfilePicture(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/update/profilepic?delete=true',
        data: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  }
}
export default recruiterService
